import {OnInit, Injectable} from '@angular/core';

declare let THREE: any;
import {StageService} from '../../../../services/stage.service';
import {ObjectCheckerService} from '../../../../services/object-checker.service';
import {CollisionService} from '../../../../services/collision/collision.service';
import {GeometryHelperService} from '../../../../services/geometry-helper.service';
import {IHandler} from './IHandler';
import {Select3dService} from '../../../../services/select-3d.service';

@Injectable()
export class RotateHandlerBase implements IHandler {

  protected direction: any;
  name: string;

  colliderCache: any;

  constructor(
    name,
    direction,
    protected StageSrvc: StageService,
    protected objectCheckerSrvc: ObjectCheckerService,
    protected collisionSrvc: CollisionService,
    protected geometryHelper: GeometryHelperService,
    protected Select3D: Select3dService
  ) {
    this.name = name;
    this.direction = direction;
  }

  invoke(selected) {
    this.rotate(selected);
    return false;
  }

  private isCollide(draggedObjs, staticObjs, angle) {

    let i = 0;
    let isCollide = false;
    let obj;

    for (; i < draggedObjs.length; i++) {

      obj = draggedObjs[i];

      obj.updateMatrixWorld();

      const rotation = new THREE.Euler()
        .setFromQuaternion(obj.getWorldQuaternion());
      rotation.y += angle;

      isCollide = this.collisionSrvc.isCollide(obj, staticObjs, {
       // newPosition: obj.getWorldPosition(new THREE.Vector3()),
        newRotation: rotation
      });

      if (isCollide) {
        break;
      }

    }

    return isCollide;
  }

  private rotate(objects) {
    if (!Array.isArray(objects)) objects = [objects];

    const rotationDegree = objects[0].userData.entity.defaultRotationDegree || 5;
    const rotationDelta = THREE.Math.degToRad(rotationDegree) * this.direction;

    for (let i = 0; i < objects.length; i++) {
      const obj = objects[i];

      const staticObjects = this.StageSrvc.getAllExceptTheObject(objects[0])
        .filter(o => o.name !== 'floor');

      const isCollide = this.isCollide(
        objects,
        staticObjects,
        rotationDelta
      );

      if (!isCollide) {
        obj.rotation.y += rotationDelta;
      }
    }

  }

  canExecute(objects) {
    var i = 0,
      obj;
    for (; i < objects.length; i++) {
      obj = objects[i];
      if (this.objectCheckerSrvc.isWallOrFloor(obj)
        || this.objectCheckerSrvc.iteractWithWall(obj))
        return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectControls/Handlers/RotateHandlerBase.ts